export default function ButtonSubmit () {
    return (
      <div>
        <button
          className="md:text-4xl inline-flex items-center justify-center w-full md:px-4 py-2 mx-auto text-lg text-black font-norse bg-transparent rounded-md border border-black border-solid cursor-pointer transition-colors hover:bg-black hover:text-gray-200 md:w-auto"
        >
          ENVIAR
        </button>
      </div>
    )
  }